import { ButtonVariant, StatusInfoModal, StatusInfoTypes } from '@catalyze/ui';
import { Routes } from 'constants/routes';
import { Spacer } from 'features/SignUp/components/forms/DocusSignForm/styled';
import {
    FormSubtitle,
    FormTitle,
} from 'features/SignUp/components/FormTitle/styled';

import { StyledButton, StyledStatusInfoModal } from './styled';

export const EmailTokenCheckInbox = () => (
    <StyledStatusInfoModal type={StatusInfoTypes.SUCCESS} bigPadding>
        <FormTitle>Check your inbox</FormTitle>
        <FormSubtitle>
            We&apos;ve sent you new link for account activation.
        </FormSubtitle>
    </StyledStatusInfoModal>
);

export const EmailTokenErrorMsg = () => (
    <StyledStatusInfoModal type={StatusInfoTypes.ERROR}>
        <FormTitle>Validation link has expired</FormTitle>
        <Spacer />
        <StyledButton
            forwardedAs="a"
            href={Routes.MAIN_SITE_SIGN_UP}
            variant={ButtonVariant.PRIMARY}
        >
            Sign up again
        </StyledButton>
    </StyledStatusInfoModal>
);

export const SuccessInfoMsg = () => (
    <StatusInfoModal type={StatusInfoTypes.SUCCESS}>
        <FormTitle>Your password has been successfully changed</FormTitle>
        <Spacer />
        <StyledButton
            forwardedAs="a"
            href={Routes.SIGN_IN}
            variant={ButtonVariant.PRIMARY}
        >
            Sign in
        </StyledButton>
    </StatusInfoModal>
);

export const ErrorInfoMsg = () => (
    <StatusInfoModal type={StatusInfoTypes.ERROR}>
        <FormTitle>Error occured while setting a password</FormTitle>
        <FormSubtitle>Please try again later</FormSubtitle>
    </StatusInfoModal>
);
